import { Component, ElementRef, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MessageServiceService } from '../../_servizi/message-service.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { CantinaService } from '../../_servizi/cantina.service';
import * as moment from 'moment';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';

@Component({
  selector: 'app-tipi-visite-layout-base',
  templateUrl: './tipi-visite-layout-base.component.html',
  styleUrls: ['./tipi-visite-layout-base.component.css']
})
export class TipiVisiteLayoutBaseComponent {

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  @Input() codiceForm: any;
  @Input() linguaCorrente: string;
  @Input() tipivisite: any;
  @Input() cart: boolean;
  @Input() collegate: boolean;

  codiceFormGiusto: string;

  tipovisitaSelezionata: any = null;
  tipovisitaArray = [];

  get colori() {
    return this.appoggioService.getColoriIframe();
  }

  constructor(
    private messageService: MessageServiceService,
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService
  ) { }


  ngOnInit(): void {

  }

  checkRegalabile(tipovisita): boolean {
    let regalabile = true;
    if (tipovisita.regala && tipovisita.tiporegala === 'gg') {
      regalabile = true;
    } else if (tipovisita.regala && tipovisita.tiporegala === 'data') {
      const dataScadenza = moment(tipovisita.fineregala);
      if (dataScadenza.isAfter(moment(), 'day')) {
        regalabile = true;
      } else {
        regalabile = false;
      }
    } else {
      regalabile = false;
    }
    return regalabile;
  }

  goToRegaloCantineWine(tipovisita) {
    window.open("https://www.cantine.wine/booking/it/" + tipovisita.modrewrite + '/regala-visita/' + tipovisita.id, "_blank");
  }

  chooseCostoMinimo(tipovisita) {
    return tipovisita.costoDefault;
  }

  apriDettaglioTipovisita(idx, tipovisita) {
    this.cantinaService.setIdxTvSelezionato(null);
    this.tipovisitaArray = [];
    this.tipovisitaSelezionata = tipovisita;
    this.codiceFormGiusto = this.collegate ? tipovisita.codiceForm : this.codiceForm;
    this.tipovisitaArray.push(this.tipovisitaSelezionata);
    this.cantinaService.setIdxTvSelezionato(idx);
    this.scrollTO('dettaglio')
  }

  goBack() {
    const idx = this.cantinaService.getIdxTvSelezionato();
    if (idx) {
      this.scrollTO('tipovisita__' + idx);
    }

    this.tipovisitaSelezionata = null;
    this.tipovisitaArray = [];
    this.cantinaService.setIdxTvSelezionato(null);
  }

  tornaIndietro() {
    this.tipovisitaSelezionata = null;
    this.tipovisitaArray = [];

    const idx = this.cantinaService.getIdxTvSelezionato();
    if (idx) {
      this.scrollTO('tipovisita__' + idx);
    }

    this.cantinaService.setIdxTvSelezionato(null);
  }

  scrollTO(target) {
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 200);
  }

  sistemaTitolo(titolo) {
    let titoloReturn = titolo;
    if (titoloReturn) {
      if (this.appoggioService.getFromMobile()) {
        if (titolo.length > 60) {
          titoloReturn = titolo.substring(0, 50);
          titoloReturn += '...';
        }
      } else {
        if (titolo.length > 60) {
          titoloReturn = titolo.substring(0, 60);
          titoloReturn += '...';
        }
      }
    }
    return titoloReturn;
  }
}
